<template>
  <div class="typeInfo">
    <main-title :title="header_title">
      <!-- <div
        v-if="location_country !== 'RU'"
        slot="top"
        class="city-area"
        @click="handleClick('city')"
      >
        <div class="choose-city">
          <i></i>
          <label v-if="_area.text">{{ _area.text }}</label>
          <label v-else class="select-txt">{{ $t("city.selectTxt") }}</label>
        </div>
      </div> -->
    </main-title>
    <div v-if="showTypeInfo" style="position:relative;padding-bottom:2.5rem">
      <div class="typeInfoContent">
        <type-card
          :key="idx"
          v-for="(item, idx) in typeCardArr"
          :title="item.title"
          :desc="item.sub_title"
          :type-id="item.identify_type+''"
          :index="item.identify_type"
          :is-checked="identity == item.identify_type"
          :disabled="!!item.disabled"
          @choose="handleClick"
        ></type-card>
      </div>
      <div :class="['btn-wraper', {'offline_offsite_wraper': offline_offsite}]">
        <p class="text-link" v-show="location_country !== 'EC'&&location_country !== 'PR'&&location_country !== 'ZA'">
          <span @click="showSite">{{ offline_offsite.title }}</span>
        </p>
        <input
          type="button"
          :value="$t('typeInfo.next_btn_desc')"
          :class="[{ active: isCanSubmit }, { 'active-br':  isCanSubmit && location_country === 'BR'}]"
          :disabled="!isCanSubmit"
          @click="handleClick('submit')"
        />
        <offline-site ref="offlineSite" :config="offline_offsite || {}"></offline-site>
      </div>
    </div>

    <div v-if="!showTypeInfo">
      <ul>
        <li class="otherCityTxt" v-for="(item, idx) in otherCityTextList" :key="idx" v-html="item"></li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import { post } from "../tools/request";
import { showDialog, showAlertDialog, showLoadingToast } from "../tools/Tip";
import { SERVICE_PHONE, SUPPORT_COUNTRY, ends } from "../tools/constant";
import { computeJumpTime, computeStayTime } from '../tools/utils'

import MainTitle from "../components/base/main-title";
import TypeCard from "../components/base/type-card";
import OfflineSite from "../components/base/offline-site";

const OTHER_CITY_ID = 12345678;

export default {
  name: "typeInfo",
  mounted() {
    //解决非正常流程进入--页面刷新，多次请求的bug，旧的i8n作用域已不存在，js有抛错，中断执行，，所以不会触发fn，很hack的做法
    this.timeId = setTimeout(this.getPageConfig, 0);
    // this.ab_text();
    this.initData();
    try {
      computeJumpTime(this)
    } catch (error) {}
    Omega.trackEvent("gd_driverRole_view_sw");
  },
  data() {
    return {
      timeId: null,
      areaId: "",
      // areaName: "",
      identity: "",
      identityInfo: {
        3: {
          key: "3",
          title: this.$t("drivingPartner"),
          desc: this.$t("typeInfo.drivingPartner_desc"),
        },
        1: {
          key: "1",
          title: this.$t("driver"),
          desc: this.$t("typeInfo.driver_desc"),
        },
        2: {
          key: "2",
          title: this.$t("nonDrivingPartner"),
          desc: this.$t("typeInfo.nonDrivingPartner_desc"),
        },
        4: {
          key: "4",
          title: this.$t("Others_optimization_IE_Driver_NXxZ"),
          desc: this.$t("Others_optimization_Your_own_lQpB"),
        },
        13: {
          key: "13",
          title: this.$t("GDriver_fleet_I_have_MLZw"),
          desc: this.$t("GDriver_fleet_I_want_xBbL").replace(/{{brand_name}}/, this.$t("GDriver_Name_99_mpNh"))
        },
      },
      showOffline: true,
      showTypeInfo: true,
      configData: {}
      // title: this.$t("typeInfo.title"),
    };
  },
  computed: {
    ...mapState([
      "_ticket",
      "_area",
      "_identity",
      "_product",
      "_uuid",
      "_mx_type_product_text",
      "_ru_se_driver_switch_test",
      "_page_stay_time",
      "_page_jump_time",
      "_route_path"
      ]),
    location_country() {
      return new URLSearchParams(location.search).get("location_country");
    },
    header_title() {
      return ((this.configData.title || [])[0] || {}).prompt;
    },
    offline_offsite() {
      return (this.configData.button_offline || [])[0] || {};
    },
    // @20210219 角色选择页配置化改造
    typeCardArr() {
      return this.configData.identify_option || [];
    },
    isCanSubmit() {
      // //@20200901 俄罗斯流程优化，去除角色页城市选择
      // if (this.location_country === "RU") {
      //   return !!this.identity;
      // }
      // return !!(this.areaId && this.identity);
      // @20210319 配置平台配置的页面没有城市选择
      return !!this.identity;
    },
    otherCityTextList() {
      const arr = [
        this.$t("typeInfo.other_city_txt1"),
        this.$t("typeInfo.other_city_txt2"),
      ];
      let TEL = SERVICE_PHONE[this.location_country] || "";
      return arr.map((item) => {
        return item.replace(
          /\{tel\}/,
          `<a href=tel:${TEL} style="color:#FF7226">${TEL}</a>`
        );
      });
    },
  },
  methods: {
    ...mapMutations(["setState"]),
    showSite() {
      this.$refs.offlineSite.getLineSite();
      this.$refs.offlineSite.show();
    },
    ab_text() {
      if (this._mx_type_product_text && this.location_country === "MX" && this._product == 2) {
        this.title = "¿Cómo quieres registrarte?";
        this.identityInfo[3].title = "Socio conductor";
        this.identityInfo[3].desc = "Para registrarte con un vehículo.";
        this.identityInfo[1].title = "Conductor";
        this.identityInfo[1].desc = "Para registrarte sin vehículo y conducir un auto registrado en DiDi por alguien más.";
        this.identityInfo[2].title = "Socio";
        this.identityInfo[2].desc = "Para registrar vehículos y que los maneje alguien más.";
      }
    },
    initData() {
      if (this._area.value) {
        this.areaId = this._area.value;
        // this.areaName = this._area.text;
        if (this._area.value === OTHER_CITY_ID) {
          this.title = "";
          this.showTypeInfo = false;
        }
      } else {
        let up = new URLSearchParams(location.search);
        if (!ends.isFleetApp && up.get('hasBrFleetReg') !== '1') {
          this.getLocation();
        }
      }
      // this._identity && (this.identity = this._identity);
    },
    handleClick(tag, payload) {
      switch (tag) {
        case "city":
          this.$router.push({ name: "city" });
          break;
        case "identity":
          this.identity = payload;
          this.setState({
            _identity: this.identity,
          });
          try {
            Omega.trackEvent("gd_driverRole_btn_ck", "", {
              driver_role: this.identity,
            });
          } catch (e) {}
          break;
        case "submit":
          showDialog(this, {
            type: "confirm",
            content: this.$t("typeInfo.submit_tips").replace(
              /{role}/,
              this.identityInfo[this.identity].title
            ),
            icon: "cubeic-alert",
            confirmBtn: {
              text: this.$t("typeInfo.OK"),
            },
            cancelBtn: { text: this.$t("typeInfo.Back") },
            onConfirm: this.handleSubmit,
          });
        default:
          break;
      }
    },
    handleSubmit() {
      // 不提交信息,暂存在store中，在baseInfo页面中一起提交
      if (!this.isCanSubmit) return;
      try {
        Omega.trackEvent("gd_driverRoleSubmit_btn_ck", "", {
          driver_role: this.identity,
          ibt_crm_uid: this._uuid,
        });
        gtm({ 'event': 's5ObIdSelection',
          'Identity': this._identity,
           'error': 'false' })
      } catch (e) {}

      this.$router.replace({
        name: `baseInfo${SUPPORT_COUNTRY[this.location_country]||"Mx"}`,
      });
    },
    getLocateCity(lng, lat) {
      let up = new URLSearchParams(location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      if (!up.get("lng")) {
        up.set("lng", lng);
        up.set("lat", lat);
      }
      post(process.env.GETCITY_URL, up)
        .then((data) => {
          this.areaId = data.value;
          // this.areaName = data.text;
          this.setState({
            _area: {
              text: data.text,
              value: data.value,
            },
            _open_type: data.open_type,
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getLocation() {
      let up = new URLSearchParams(location.search);
      let lng = up.get("lng");
      let lat = up.get("lat");
      if (lat && lng) {
        this.getLocateCity(lng, lat);
      } else {
        let that = this;
        /**
         *  获取经纬度信息
         *  position_option 获取经纬度信息的配置项
         *  getPositionSuccess 信息获取成功函数
         *  getPositionError 信息获取失败函数
         */
        var position_option = {
          enableHighAccuracy: true, //告诉浏览器是否启用高精度设备
          maximumAge: 30000, //单位毫秒，告诉设备缓存时间，主要用于设备的省电或者节省带宽方面
          timeout: 3000, //超时时间
        };
        navigator.geolocation.getCurrentPosition(
          getPositionSuccess,
          getPositionError,
          position_option
        );
        function getPositionSuccess(position) {
          // that.locationInfo.lng = position.coords.longitude;
          // that.locationInfo.lat = position.coords.latitude;
          that.getLocateCity(
            position.coords.longitude,
            position.coords.latitude
          );
        }
        function getPositionError(e) {
          console.log(e);
        }
      }
    },
    defaultIdentity () {
      let default_identity_option = (this.configData.identify_option || []).filter(item => !!item.default_select);
      // 如果配置了默认角色就选中
      if (default_identity_option && default_identity_option[0]) {
        this.identity = default_identity_option[0].identify_type
        this.setState({
          _identity: this.identity,
        });
      } else {
        // 没有配置默认角色就去store里的
        this._identity && (this.identity = this._identity);
      }

    },
    getPageConfig() {
      showLoadingToast(this, this.$t("加载中"));
      let up = new URLSearchParams(window.location.search);
      //兼容各个国家情况，vuex中如果存在ticket，则优先信任
      if (this._ticket) {
        up.set("ticket", this._ticket);
      }
      up.set("page_name", "identify_option_page");
      post(process.env.PREORDER_INFO, up)
        .then(data => {
          this.configData = data || {};
          this.defaultIdentity();
        })
        .catch(err => {
          showAlertDialog(this);
        })
        .finally(() => {
          this.toast.hide();
        });
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeId);
    try {
      computeStayTime(this)
    } catch (error) {}
  },
  components: {
    MainTitle,
    TypeCard,
    OfflineSite,
  },
};
</script>
<style lang="scss" scoped>
.typeInfo {
  .city-area {
    padding: 0.04rem;
    margin-bottom: 0.36rem;
    .choose-city {
      display: flex;
      align-items: center;
      width: 100%;
      height: 0.9rem;
      background: #fff;
      line-height: 0.9rem;
      padding: 0 0.44rem 0 0.32rem;
      box-sizing: border-box;
      position: relative;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      label {
        font-size: 0.4rem;
      }
      .select-txt {
        font-size: 0.28rem;
        color: #999;
      }
      & > i {
        border: 7px solid transparent;
        border-top-color: #000;
        position: absolute;
        top: 50%;
        right: 0.2rem;
        transform: translateY(-25%);
      }
    }
  }
  .typeInfoContent {
    margin-bottom: 0.8rem;
  }
  .otherCityTxt {
    padding: 0 0.32rem;
    margin-bottom: 0.36rem;
    line-height: 1.3;
    font-size: 0.4rem;
  }
  .btn-wraper {
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0.43rem 0.31rem;
    input {
      width: 6.84rem;
      height: 1.06rem;
      font-size: 0.4rem;
      color: #999;
      text-align: center;
      background-color: #eee;
      border-radius: 0.06rem;
    }
    .active {
      color: #fff;
      background: linear-gradient(45deg, #ff5b1d, #ff7f41);
    }
    .active-br {
      background: #FFDC14;
      color: #333333;
    }
  }
}
</style>
